import React, { useCallback } from 'react'
import { Link } from 'react-router-dom'
import SupportListWrapper from 'core/page/SupportListWrapper'
import { IExtendedColumn } from '@cbgms/components/grid/Types'
import N from 'utils-support/navigation'
import { ISupportShop } from '@cbgms/api/modules/shops'
import { ICompany } from '@cbgms/api/modules/company'
import { listShops, updateShopsMijnGrossierRedirect } from '../state/actions'
import { useMultiSelection } from '@cbgms/base/hooks/use-multi-selection'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useNotifier } from '@cbgms/base/notifier'
import { ConfirmDialog } from '@carsys/ui'
import { useShopQueryByStatus } from '../hooks/useShopQueryByStatus'
import { ShopStatus } from '@cbgms/api'
import { Button } from '@mui/material'
import { Menu } from 'semantic-ui-react'
import { MenuItem } from 'core/page/MenuItem'

export interface ShopListRow {
  Shop: ISupportShop
  Company: ICompany
}

export const onEdit = (data: ShopListRow) => {
  N.push(`/companies/${data.Company.UUID}/shops/edit/${data.Shop.ID}`)
}

export const mapLinkToColumn = (columns: IExtendedColumn[]) =>
  columns.map(col => ({
    ...col,
    action:
      col.key === 'Company.Name'
        ? ({ data }: { data: ShopListRow }) => <Link to={`/companies/edit/${data.Company.UUID}`}>{data.Company.Name}</Link>
        : col.action
  }))

export const ShopsList = () => {
  const { selectedItems, ListCheckbox, refreshSelection } = useMultiSelection((row: ShopListRow) => row.Shop.ID)
  const { statusType, setStatusType, apiSearchQuery } = useShopQueryByStatus()
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const notifier = useNotifier()
  const [isConfirming, setIsConfirming] = React.useState(false)

  const enableRedirect = useCallback(async () => {
    await dispatch(updateShopsMijnGrossierRedirect(selectedItems))
    refreshSelection()
    setIsConfirming(false)
    notifier.success(t('global.successfully_saved'))
  }, [selectedItems])

  return (
    <>
      <ConfirmDialog
        open={isConfirming}
        title={t('shop.enable_mijngrossier_redirect', { count: selectedItems.length })}
        content={t('shop.enable_mijngrossier_redirect_confirm')}
        cancelButtonContent={t('global.cancel')}
        confirmButtonContent={t('global.confirm')}
        onClose={() => setIsConfirming(false)}
        onConfirm={enableRedirect}
      />
      <SupportListWrapper
        scope='shops'
        onColumnMap={mapLinkToColumn}
        onEdit={onEdit}
        loadAction={listShops}
        translationKey='shops'
        predefinedSearch={apiSearchQuery}
        middleMenuItems={
          <MenuItem>
            <Button variant='contained' disabled={!selectedItems.length} onClick={() => setIsConfirming(true)}>
              {t('shop.enable_mijngrossier_redirect', { count: selectedItems.length })}
            </Button>
          </MenuItem>
        }
        startActions={ListCheckbox}
        tabItems={
          <>
            <Menu.Item active={statusType === ShopStatus.Active} onClick={() => setStatusType(ShopStatus.Active)}>
              {t('shop.tab_status_active')}
            </Menu.Item>
            <Menu.Item active={statusType === ShopStatus.Archive} onClick={() => setStatusType(ShopStatus.Archive)}>
              {t('shop.tab_status_archive')}
            </Menu.Item>
            <Menu.Item active={statusType === ShopStatus.Internal} onClick={() => setStatusType(ShopStatus.Internal)}>
              {t('shop.tab_status_internal')}
            </Menu.Item>
            <Menu.Item active={statusType === ShopStatus.Demo} onClick={() => setStatusType(ShopStatus.Demo)}>
              {t('Enum.EnumShopStatus_demo')}
            </Menu.Item>
            <Menu.Item active={statusType === 'all'} onClick={() => setStatusType('all')}>
              {t('shop.tab_status_all')}
            </Menu.Item>
          </>
        }
      />
    </>
  )
}

export default ShopsList
